import { Logo } from "./Logo";


export const Footer = () => {
  return (
    <footer className="relative bg-navy text-paper">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-12 gap-6 md:gap-10">
          <div className="col-span-12 md:col-span-7">
            <Logo tone="onDark" size="lg" />
            <p className="font-display italic text-3xl md:text-5xl mt-8 max-w-3xl leading-tight">
              Making invisible businesses <span className="text-teal">visible</span>.
            </p>
          </div>

          <div className="col-span-7 md:col-span-3">
            <div className="font-mono-cap text-paper/50 mb-4">Contact</div>
            <a
              data-testid="footer-email"
              href="mailto:Ashwin.Shetty@kadellabs.com"
              className="block font-sans text-paper hover:text-teal transition-colors text-sm md:text-base break-words"
              style={{ wordBreak: "break-word" }}
            >
              Ashwin.Shetty@kadellabs.com
            </a>
          </div>

          <div className="col-span-5 md:col-span-2">
            <div className="font-mono-cap text-paper/50 mb-4">Location</div>
            <div className="font-sans text-paper/85 text-sm md:text-base">
              Bangalore · Remote
            </div>
          </div>
        </div>

        <div className="border-t border-paper/15 mt-16 pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="font-mono-cap text-paper/50">
            © {new Date().getFullYear()} Credablr. All rights reserved.
          </div>
          <div className="font-mono-cap text-paper/50">
            A fintech concept · Not a live product
          </div>
        </div>
      </div>
    </footer>
  );
};
